import React, { useState } from "react";

import "./index.sass";
import { useTranslation } from "react-i18next";
import Context from "../../../../../../../../context";
import {
  CustomButton2,
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../../../../components";
import api from "../../../../../../../../api";
import successHandler from "../../../../../../../../utils/successHandler";

const Block = () => {
  const {
    showModal,
    setShowModal,
    selectedPayment,
  } = React.useContext(Context.ApproveParentTransactionScreen);

  const [textArea, setTextArea] = useState<string>("");

  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);


  const blockFunction = async(item: any) => {
    setIsLoading(true);
    const result = await api.get.administrator.disapproveparentTransaction({
      transactionId: item?._id,
    });
    if (result?.CODE === 2213) {
      setIsLoading(false);
      setShowModal("NONE");
      successHandler(2010)
    }
  };

  console.log({selectedPayment})

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CANCEL_PARENT_TRANSACTION_MODAL"}
        label={t("disApprove")}
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedPayment?.firstName}
                avatar={selectedPayment?.avatar}
                isBlock={
                  !selectedPayment?.driverInformation?.approved?.isApproved
                }
                lastName={selectedPayment?.lastName}
                phoneNumber={selectedPayment?.phoneNumber}
              />
            </CustomView.Column>
            <CustomView.Column
              medium={8}
              className="form-colum dropdown description-input"
            >
              <label className="form-label">{t("description")}</label>
              <textarea
                cols={33}
                rows={3}
                onChange={(e) => setTextArea(e.target.value)}
              >
                {textArea}
              </textarea>
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title={t("cancel")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() =>
                  blockFunction!(selectedPayment)
                }
                title={t("disApprove")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Block;
